import { SVGProps } from "react";
import styles from "../variants/01/sw-categories-variant-01.module.scss";

export const CategorySUVSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 728.2 273.5"
    style={{
      // @ts-ignore
      enableBackground: "new 0 0 728.2 273.5",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path
      className={styles.st0}
      d="M150.1 170.7c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9-41.9-18.8-41.9-41.9 18.9-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.2-60.9-60.9-60.9zM606.8 170.7c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9-41.9-18.8-41.9-41.9 18.8-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9z"
    />
    <path
      className={styles.st0}
      d="m728.2 159.2-2.1-.3c-.3 0-7.2-1.2-9-8.2-.2-1-.6-2.4-1-4.1-3.2-14.5-10.8-48.5-30.2-52.3L522.2 73.1c-10.4-1.3-20.4-5.2-28.9-11.2C434.4 20.2 399.2 0 385.7 0 362.2 0 69.4 7.4 66.4 7.5c-2.2.1-3.2 2.6-1.8 4.2l9.6 10.1C69.4 26 56.4 37.5 43.6 50 10.4 82.5 10.4 90.5 10.4 93.1v42.5C6 136.9 0 140.6 0 148v30.5c.1.4 1.4 10.8 12.1 21 13 12.5 33.6 19.2 61.1 20.1 1.7 0 3.3.1 5 .1-.2-1.7-.3-3.3-.3-5v-.5c-.8-38.5 29-71.1 67.4-73.7 42.1-2.8 77.2 30.6 77.2 72.1 0 1.1 0 2.2-.1 3.2-.1 1.7-.2 3.3-.4 5h5l303.2 2.5h5.1c-.2-1.7-.4-3.3-.6-5-.2-1.9-.2-3.8-.2-5.8 0-40.4 33.3-73.1 73.8-72.3 38.4.8 69.8 32.1 70.7 70.5.1 2.9 0 5.8-.3 8.7-.2 1.7-.4 3.3-.6 5h5.1c.4 0 1.8.1 3.8.1 8 0 26-1 35.3-9.9 4-3.7 6-8.4 6-13.8v-39.6l-.1-2zm-5 41.7c0 4.1-1.4 7.4-4.4 10.2-9.7 9.1-32.1 8.5-35.2 8.4.2-2.2.3-4.5.3-6.8.1-41-32.3-75.3-73.2-77.3-44.4-2.3-81.3 33.2-81.3 77.2 0 1.9.1 3.8.2 5.7l-302.4-2.4c.1-1.1.1-2.2.1-3.3 0-42.6-34.7-77.3-77.3-77.3S72.9 170 72.9 212.6v2c-32-1.1-48.6-10.5-57.1-18.4-9-8.5-10.6-17.1-10.8-18.2v-30c0-6.5 8-7.9 8.3-8l2.1-.3V93.1c0-10.3 39.3-47.9 64.1-69.2 1.1-.9 1.2-2.6.2-3.6l-7.5-7.9c41-1 292-7.3 313.6-7.3 12.2 0 47.5 20.5 104.7 60.9 9.2 6.5 20 10.7 31.1 12.1l163.5 21.1c16.2 3.2 23.5 36 26.2 48.4.4 1.8.7 3.2 1 4.3 1.9 7.5 7.8 10.3 11 11.4v37.6z"
    />
    <path
      className={styles.st0}
      d="M218.3 102.2h-25.6c-2.7 0-5-2.2-5-5 0-2.7 2.2-5 5-5h25.6c2.7 0 5 2.2 5 5s-2.2 5-5 5zM379 107.2h-25.6c-2.7 0-5-2.2-5-5 0-2.7 2.2-5 5-5H379c2.7 0 5 2.2 5 5s-2.2 5-5 5zM57.8 72.8l64.7-52.5c3.3-2.7 7.3-4.1 11.5-4.2 35.2-.7 203.5-4.1 261.2-2.5l74.9 50.3c3.6 2.4 4.5 7.3 2.1 10.8l-5.9 8.7c-1.6 2.5-4.4 3.9-7.4 3.8L59.3 77c-2.2 0-3.2-2.8-1.5-4.2z"
    />
  </svg>
);
